{
  "title": "Betriebs-Posteingang",
  "tabTitles": {
    "urgent": "🔴 ({{count}}) Betriebspostfach",
    "actionable": "({{count}}) Operations-Posteingang",
    "default": "Betriebsposteingang",
    "appDefault": "AirPlx"
  },
  "header": {
    "timeFilters": {
      "today": "Heute",
      "tomorrow": "Morgen",
      "week": "Diese Woche",
      "all": "Alle"
    },
    "statusLabels": {
      "allSetToday": "Alles bereit für heute",
      "nothingTomorrow": "Morgen nichts",
      "clearForWeek": "Für die Woche löschen",
      "allCaughtUp": "Alles erledigt!",
      "arrivalsToday": "{{count}} Ankunft heute",
      "arrivalsTomorrow": "{{count}} Ankunft morgen",
      "arrivalsWeek": "{{count}} Ankunft diese Woche",
      "total": "{{count}} insgesamt"
    },
    "newTails": "{{count}} neu",
    "searchPlaceholder": "Suche Kennung, Typ, Betreiber...",
    "refreshStatus": {
      "refreshing": "Aktualisiere...",
      "updated": "Aktualisiert {{timeAgo}}",
      "justNow": "gerade eben",
      "secondsAgo": "vor {{count}}s",
      "minuteAgo": "vor 1 M.",
      "minutesAgo": "vor {{count}}m"
    }
  },
  "groups": {
    "unknownAircraft": {
      "title": "NEUE TAILS",
      "tooltip": "Erstbesucher, die in deinem System eingerichtet werden müssen. Ordne sie bestehenden Flugzeugen zu oder erstelle neue Einträge."
    },
    "needsRouting": {
      "title": "PARKPOSITION ZUWEISEN",
      "tooltip": "Ankünfte, die eine Parkzuweisung benötigen. Wähle für jede einen Hangar oder eine Abstellfläche."
    },
    "snoozed": {
      "count": "Zurückgestellt ({{count}})",
      "tooltip": "Vorübergehend ausgeblendete Elemente. Sie erscheinen wieder in deinem Posteingang, wenn die Schlummerzeit endet.",
      "snoozedUntil": "Zurückgestellt bis {{date}}"
    }
  },
  "actionTypeGroup": {
    "urgencyLabels": {
      "now": "JETZT",
      "today": "HEUTE"
    },
    "itemCount": "{{count}} Element (eingeklappt)",
    "noItems": "Keine Einträge in dieser Gruppe"
  },
  "bulkActions": {
    "selected": "{{count}} ausgewählt",
    "breakdown": "({{quarantineCount}} unbekannt, {{tripCount}} Trips)",
    "mapAllTo": "Alle zuordnen zu...",
    "snoozeAll": "Alle pausieren",
    "buttons": {
      "mapToAircraft": "Flugzeug zuordnen",
      "assignLocation": "Standort zuweisen"
    }
  },
  "assignDropdown": {
    "assignTo": "Zuweisen an...",
    "searchPlaceholder": "Suchen...",
    "hangarsSection": "HANGARS",
    "rampsSection": "RAMPEN",
    "tooSmall": "Zu klein",
    "noDimensions": "Keine Maße",
    "noMatchingLocations": "Keine passenden Standorte",
    "noLocationsAvailable": "Keine Standorte verfügbar",
    "dimensions": {
      "width": "{{width}}'B",
      "depth": "{{depth}}'D",
      "height": "{{height}}'H"
    }
  },
  "snooze": {
    "title": "Erinnern bis",
    "dateFormat": {
      "todayAt": "Heute um {{time}}",
      "tomorrowAt": "Morgen um {{time}}"
    }
  },
  "messages": {
    "mapped": "Zugeordnet {{tailNumber}} → {{aircraftName}}",
    "assigned": "{{tailNumber}} wurde {{locationName}} zugewiesen",
    "snoozed": "Schlummert {{tailNumber}}",
    "unsnoozed": "{{tailNumber}} reaktiviert",
    "bulkSnoozed": "{{count}} Elemente zurückgestellt",
    "bulkMapped": "{{count}} Flugzeuge zu {{aircraftName}} zugeordnet",
    "bulkMappedPartial": "Zugeordnet {{successCount}}/{{totalCount}} ({{failCount}} fehlgeschlagen)",
    "bulkAssignedHangar": "{{count}} Flüge an {{locationName}} zugewiesen",
    "bulkAssignedRamp": "{{count}} Flüge zu {{locationName}} zugewiesen",
    "bulkAssignedHangarPartial": "{{successCount}}/{{totalCount}} Trips zugewiesen (fehlgeschlagen: {{sampleFails}}{{moreFails}})",
    "bulkAssignedRampPartial": "{{successCount}}/{{totalCount}} Trips zugewiesen (fehlgeschlagen: {{sampleFails}}{{moreFails}})",
    "bulkAssignedHangarFailed": "Zuweisen der Trips fehlgeschlagen: {{sampleFails}}{{moreFails}}",
    "bulkAssignedRampFailed": "Zuweisen der Trips fehlgeschlagen: {{sampleFails}}{{moreFails}}"
  },
  "errors": {
    "resolveFailed": "Fehler beim Auflösen von {{tailNumber}}: {{error}}",
    "assignFailed": "Zuweisung fehlgeschlagen: {{error}}",
    "snoozeFailed": "Schlummern fehlgeschlagen: {{error}}",
    "unsnoozeFailed": "Entschlummern fehlgeschlagen: {{error}}",
    "bulkResolveFailed": "Massenauflösung fehlgeschlagen: {{error}}",
    "unknownError": "Unbekannter Fehler",
    "loadFailed": "Posteingang laden fehlgeschlagen: {{error}}"
  },
  "emptyStates": {
    "today": {
      "title": "Alles bereit für heute!",
      "message": "Keine Ankünfte benötigen Parkplatzzuweisungen.",
      "laterThisWeek": "{{count}} Ankünfte später diese Woche",
      "newTailsToSetup": "{{count}} neue Tails einzurichten",
      "previewThisWeek": "Vorschau dieser Woche",
      "setupNewTails": "Neue Kennzeichen anlegen"
    },
    "tomorrow": {
      "title": "Nichts für morgen geplant",
      "message": "Schau später nochmal vorbei oder zeige alle Ankünfte an.",
      "viewAll": "Alle zeigen"
    },
    "week": {
      "title": "Für die Woche löschen",
      "message": "Alle Ankünfte wurden Parkpositionen zugewiesen.",
      "setupNewTails": "{{count}} neue Luftfahrzeuge einrichten"
    },
    "all": {
      "title": "Alles erledigt!",
      "message": "Keine Einträge erfordern gerade deine Aufmerksamkeit."
    }
  },
  "quarantineCard": {
    "noTypeHint": "Kein Typhinweis",
    "buttons": {
      "matchTo": "Zuordnen zu {{type}}",
      "findAircraft": "Flugzeug suchen",
      "later": "Später"
    },
    "labels": {
      "searchAircraft": "Flugzeug suchen..."
    },
    "tooltips": {
      "searchForType": "Suche nach {{type}} in der Flugzeugdatenbank"
    }
  },
  "tripCard": {
    "buttons": {
      "later": "Später"
    },
    "tooltips": {
      "aircraftTooLarge": "Flugzeug zu groß",
      "mostUsedLocation": "Meistgenutzte Location ({{count}} Zuweisungen)",
      "assignTo": "Zuweisen an {{name}}",
      "moreLocations": "Weitere Standorte"
    }
  }
}
